import { generator } from '@cms-max/cms-browser-api-client'
import { Activity, Component } from '@cms-max/medicare-api-sdk'
import { GeneratorArgs } from './generateEventMap'

export const authRepGenerator = generator((_args : GeneratorArgs) => {
  return (
    {
      // Auth Rep Print Drawer: Open
      authrep_printdrawer_opendrawer: {
        core: {
          property: 'MAX',
          activity: Activity.OpenDrawer,
          component: Component.AuthorizedRepresentative,
          elementId: 'authrep_printdrawer_opendrawer'
        }
      },
      // Auth Rep Print Drawer: Open
      authrep_printdrawer_closedrawer: {
        core: {
          property: 'MAX',
          activity: Activity.CloseDrawer,
          component: Component.AuthorizedRepresentative,
          elementId: 'authrep_printdrawer_closedrawer'
        }
      }
    }
  ) // TODO: Uncomment - jest can't handle this right now. It likely needs updated to support: satisfies GenericEventMap
})

export type AuthRepKeys = keyof ReturnType<typeof authRepGenerator>

export default authRepGenerator
